export const Lore = () => {
  return (
    <section
      id="lore"
      data-testid="lore-section"
      className="relative z-10 px-4 sm:px-8 lg:px-12 py-16"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <span className="tag">CHAPTER 01</span>
          <span className="font-luckiest text-lg">THE LORE</span>
        </div>

        <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 items-start">
          <div className="lg:col-span-7">
            <h2
              className="font-bangers leading-[0.9] text-black"
              style={{ fontSize: "clamp(38px, 6vw, 84px)" }}
            >
              It started as a clip.
              <br />
              <span style={{ color: "#0057FF", WebkitTextStroke: "2px #000" }}>
                Now it&apos;s the slang.
              </span>
            </h2>

            <div className="mt-6 space-y-5 font-luckiest text-base sm:text-lg text-black/85 leading-relaxed max-w-2xl">
              <p>
                What started out as a simple reaction video turned into the newest
                daily normie slang. Forget saying something is heat, fire, or
                gas…
              </p>
              <p
                className="font-bangers leading-none"
                style={{
                  fontSize: "clamp(36px, 5vw, 64px)",
                  color: "#0057FF",
                  WebkitTextStroke: "2px #000",
                }}
              >
                DATBIHGAH.
              </p>
              <p>
                After racking up hundreds of millions of views across TikTok, X,
                Instagram Reels, and YouTube Shorts, major streamers like Kai
                Cenat, Lacy, and thousands of other influencers and normies
                quickly adopted the phrase into their everyday content.
              </p>
              <p
                className="font-bangers text-2xl sm:text-3xl"
                style={{ color: "#000" }}
              >
                Once you hear it, you can&apos;t unhear it.
              </p>
              <p>
                What started as a reaction clip evolved into a viral catchphrase,
                and before long DATBIHGAH had communities forming around it —
                from the crypto space to everyday internet culture.
              </p>
              <p className="font-luckiest">One thing is for sure:</p>
              <p>
                <span
                  className="px-2 py-1"
                  style={{ background: "#0057FF", color: "#fff", border: "2px solid #000" }}
                >
                  Trends come and go. Memes rise and fall.
                </span>{" "}
                But{" "}
                <span
                  className="font-bangers"
                  style={{ color: "#0057FF", WebkitTextStroke: "1.5px #000" }}
                >
                  DATBIHGAH
                </span>{" "}
                is forever.
              </p>
            </div>
          </div>

          <div className="lg:col-span-5 grid grid-cols-1 gap-4">
            <StatCard
              label="the loud one"
              value="GAH"
              note="for when it hits hard"
              accent
            />
            <StatCard
              label="the lil one"
              value="TUH"
              note="for the small wins"
              soft
            />
          </div>
        </div>
      </div>
    </section>
  );
};

const StatCard = ({ label, value, note, accent, soft }) => {
  const bg = accent ? "#0057FF" : soft ? "#FFD500" : "#fff";
  const fg = accent ? "#fff" : "#000";
  return (
    <div
      className="sticker p-5 flex items-end justify-between gap-4"
      style={{ background: bg, color: fg }}
      data-testid={`stat-card-${value}`}
    >
      <div>
        <div className="font-luckiest text-xs sm:text-sm tracking-widest uppercase">
          {label}
        </div>
        <div
          className="font-bangers text-5xl sm:text-6xl leading-none mt-1"
          style={{
            color: accent ? "#fff" : "#000",
            WebkitTextStroke: accent ? "1.5px #000" : "1.5px #000",
          }}
        >
          {value}
        </div>
      </div>
      <div
        className="font-luckiest text-xs sm:text-sm text-right max-w-[160px]"
        style={{ color: accent ? "#fff" : "#000", opacity: 0.85 }}
      >
        {note}
      </div>
    </div>
  );
};
